import React from 'react';
import Component from '@vfuk/core-range-slider';
const RangeSlider = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default RangeSlider;
